import type { PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';

import messagesDE from '#components/translations/de-DE.json';
import { useAppSelector } from '#store/store.ts';

import { DEFAULT_LOCALE } from './lang.ts';
import { getDisplayMessages, getLocale } from './langSlice.ts';
import { normalizeDisplayMessages } from './messages.ts';

export const TestI18NProvider = ({ children }: PropsWithChildren) => {
    return (
        <IntlProvider locale={'de-DE'} defaultLocale={'de-DE'} messages={normalizeDisplayMessages(messagesDE)}>
            {children}
        </IntlProvider>
    );
};

export const I18NProvider = ({ children }: PropsWithChildren) => {
    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);

    if (!(displayMessages && userLocale)) {
        return null;
    }

    return (
        <IntlProvider defaultLocale={DEFAULT_LOCALE} key={userLocale} locale={userLocale} messages={displayMessages}>
            {children}
        </IntlProvider>
    );
};
